import { ModuleWithProviders, NgModule } from '@angular/core';

import { CORE_CUSTOM_CONFIG } from '@core/services/config.service';
import { coreConfig } from 'app/app-config';
import { CoreConfig } from './types';

type RecursiveKeysOfType<T> = {
  [P in keyof T]?: RecursiveKeysOfType<T[P]>;
};

@NgModule()
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: CORE_CUSTOM_CONFIG,
          useValue: coreConfig,
        },
      ],
    };
  }

  static withConfig(
    config: RecursiveKeysOfType<CoreConfig>
  ): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: CORE_CUSTOM_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}

